import BaseServiceHttp from '../baseService'
class Bibliotecas extends BaseServiceHttp {
  constructor(id) {
    const resource = 'bibliotecas'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Bibliotecas(id)
